export default __webpack_public_path__ + "static/index_hero_bg02-2aec82818dd700024179446a6bfe677b.jpg";